import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "m-menu-close_svg__Menu-Close" }, [
  /*#__PURE__*/_createElementVNode("rect", {
    id: "m-menu-close_svg__Rectangle 12",
    opacity: "0.02",
    width: "30",
    height: "30",
    rx: "4",
    fill: "#111224"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "m-menu-close_svg__Vector 1",
    d: "M10 10L20.0001 20.0002",
    stroke: "#111224",
    "stroke-width": "3",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "m-menu-close_svg__Vector 2",
    d: "M20 10L10.0014 20.0002",
    stroke: "#111224",
    "stroke-width": "3",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }